/** Main nav guided tour (dashboard auto-start + sidebar overview). */
export const MAIN_NAV_TOUR_KEY = "v1_6_main_nav_tour_complete";

/** Legacy key — treat as main nav complete for migration. */
export const LEGACY_DASHBOARD_TOUR_KEY = "v1_5_dashboard_tour_complete";

/** Settings submenu tour (first expand of Settings in sidebar). */
export const SETTINGS_TOUR_KEY = "v1_6_settings_tour_complete";

export function isMainNavTourComplete() {
  try {
    return (
      localStorage.getItem(MAIN_NAV_TOUR_KEY) === "true" ||
      localStorage.getItem(LEGACY_DASHBOARD_TOUR_KEY) === "true"
    );
  } catch {
    return false;
  }
}

export function isSettingsTourComplete() {
  try {
    return localStorage.getItem(SETTINGS_TOUR_KEY) === "true";
  } catch {
    return false;
  }
}
